<template>
    <div>
        <div class="title" v-if="item">
            <img @click="back" class="back" :src="require(`@/assets/theme/light/status/01dailyActive/01back.svg`)">
            <img @click="share" class="share-icon"  src="@/assets/theme/light/report/03month/03share.png">
            <img @click="toHistory" class="history-icon" src="@/assets/theme/light/report/03month/04history.png">
        </div>
        <div class="title-none" v-if="!item">
            <van-col span="6" @click="back"><img class="back" :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)"></van-col>
            <img @click="toHistory" class="history-icon" src="@/assets/theme/light/report/03month/04history.png">
        </div>
        <div  :class="$i18n.locale == 'en' ? 'bg-en' : 'bg' "  v-if="item">
            <div class="content">
                <div class="head-box">
                    <img class="user-img" :src="item.userAvatar? item.userAvatar : defaultImg">
                    <div class="user-name">{{item.userName}}</div>
                    <div class="time-range">{{item.monthBegin.slice(5, 10).replace(/-/g, '/')}}-{{item.monthEnd.slice(5, 10).replace(/-/g, '/')}}
                    </div>
                    <img class="run-icon" src="@/assets/report/month/run.png">
                </div>
                <div class="step-box">
                    <div class="step-ratio-box" :class="{ 'step-ratio-box-en': $i18n.locale == 'en' }" ><span class="step-ratio">{{parseInt(item.stepsRatio * 100)}}%</span></div>
                    <div class="step-total value-font">{{format(item.monthSteps)}}
                        <span class="unit" v-if="item.monthSteps==1">{{ $t('unit.step') }}</span>
                        <span class="unit" v-if="item.monthSteps>1">{{ $t('unit.steps') }}</span>
                    </div>
                    <img v-if="item.stepsVariation == 0" class="step-icon-flat" src="@/assets/report/weekly/flat.png">
                    <img v-if="item.stepsVariation > 0" class="step-icon" src="@/assets/report/month/up.png">
                    <img v-if="item.stepsVariation < 0" class="step-icon" src="@/assets/report/month/down.png">
                    <div class="step-variation value-font">{{format(item.stepsVariation)}}
                        <span class="unit" v-if="item.stepsVariation==1">{{ $t('unit.step') }}</span>
                        <span class="unit" v-if="item.stepsVariation>1">{{ $t('unit.steps') }}</span>
                    </div>
                    <div class="step-chart" id="step"></div>
                    <div class="percent">
                        <van-progress :percentage="item.stepDayComplianceRatio ? item.stepDayComplianceRatio : 1" stroke-width="9" track-color="#FFFFFF"
                                      color="linear-gradient(to right, var(--chart-color-1), #ffffff)"/>
                    </div>
                    <div class="step-complate value-font">{{item.stepDayCompliance}}
                        <span class="unit" style="color: #000000" v-if="item.stepDayCompliance==1">{{ $t('unit.day') }}</span>
                        <span class="unit" style="color: #000000" v-if="item.stepDayCompliance>1">{{ $t('unit.days') }}</span>
                    </div>
                </div>
                <div class="sport-box">
                    <div class="sport-total value-font">{{(item.duration / 3600).toFixed(2)}}
                        <span class="unit" v-if="(item.duration / 3600).toFixed(2)==1">{{ $t('unit.hour') }}</span>
                        <span class="unit" v-if="(item.duration / 3600).toFixed(2)>1">{{ $t('unit.hours') }}</span>
                    </div>
                    <img v-if="item.durationVariation == 0" class="sport-icon-flat" src="@/assets/report/weekly/flat.png">
                    <img v-if="item.durationVariation > 0" class="sport-icon" src="@/assets/report/month/up.png">
                    <img v-if="item.durationVariation < 0" class="sport-icon" src="@/assets/report/weekly/down.png">
                    <div class="sport-variation value-font">{{(item.durationVariation / 3600).toFixed(2)}}
                        <span class="unit" v-if="(item.durationVariation / 3600).toFixed(2)==1">{{ $t('unit.hour') }}</span>
                        <span class="unit" v-if="(item.durationVariation / 3600).toFixed(2)>1">{{ $t('unit.hours') }}</span>
                    </div>
                    <div class="week">

                        <div class="" v-for="(obj, i) in item.weekDurationDeal">
                            <div class="week-item" :class="{ 'value-max': obj.isMax }">{{obj.key}}</div>
                            <div class="week-item-right " :class="{ 'value-max': obj.isMax }">
                                <div>{{obj.value}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="type">
                        <div class="sport-ratio-box">
                            <div v-if="lineWidth1" class="line-1 line" :style="{'width': lineWidth1 + 'px'}"></div>
                            <div v-if="lineWidth2" class="line-2 line" :style="{'width': lineWidth2 + 'px'}"></div>
                            <div v-if="lineWidth3" class="line-3 line" :style="{'width': lineWidth3 + 'px'}"></div>
                            <div v-if="lineWidth4" class="line-4 line" :style="{'width': lineWidth4 + 'px'}"></div>
                        </div>
                        <div>
                            <div class="bar bar1"></div>
                            <div class="text text1">{{getLangSportType(item.monthDuration[0].type)}}</div>
                            <div class="value-font-mini bar-value1">{{(item.monthDuration[0].value * 100).toFixed(1)}}%
                            </div>
                        </div>
                        <div>
                            <div class="bar bar2"></div>
                            <div class="text text2">{{getLangSportType(item.monthDuration[1].type)}}</div>
                            <div class="value-font-mini bar-value2">{{(item.monthDuration[1].value * 100).toFixed(1)}}%
                            </div>
                        </div>
                        <div>
                            <div class="bar bar3"></div>
                            <div class="text text3">{{getLangSportType(item.monthDuration[2].type)}}</div>
                            <div class="value-font-mini bar-value3">{{(item.monthDuration[2].value * 100).toFixed(1)}}%
                            </div>
                        </div>
                        <div>
                            <div class="bar bar4"></div>
                            <div class="text text4">{{getLangSportType(item.monthDuration[3].type)}}</div>
                            <div class="value-font-mini bar-value4">{{(item.monthDuration[3].value * 100).toFixed(1)}}%
                            </div>
                        </div>
                        <div class="sport-num value-font">{{item.sportNumber}}
                            <span class="unit" v-if="item.sportNumber==1">{{ $t('unit.time') }}</span>
                            <span class="unit" v-if="item.sportNumber>1">{{ $t('unit.times') }}</span>
                        </div>
                        <img v-if="item.sportNumberVariation == 0" class="sport-num-icon-flat"
                             src="@/assets/report/weekly/flat.png">
                        <img v-if="item.sportNumberVariation > 0" class="sport-num-icon" src="@/assets/report/month/up.png">
                        <img v-if="item.sportNumberVariation < 0" class="sport-num-icon"
                             src="@/assets/report/weekly/down.png">
                        <div class="sport-num-variation value-font">{{Math.abs(item.sportNumberVariation)}}
                            <span class="unit" v-if="Math.abs(item.sportNumberVariation)==1">{{ $t('unit.time') }}</span>
                            <span class="unit" v-if="Math.abs(item.sportNumberVariation)>1">{{ $t('unit.times') }}</span>
                        </div>
                        <div class="sport-distance value-font">{{(item.mileage / 100000).toFixed(2)}} <span
                                class="unit">{{ $t('unit.km') }}</span></div>
                        <img v-if="item.mileageVariation == 0" class="sport-distance-icon-flat"
                             src="@/assets/report/weekly/flat.png">
                        <img v-if="item.mileageVariation > 0" class="sport-distance-icon"
                             src="@/assets/report/month/up.png">
                        <img v-if="item.mileageVariation < 0" class="sport-distance-icon"
                             src="@/assets/report/weekly/down.png">
                        <div class="sport-distance-variation value-font">{{Math.abs((item.mileageVariation /
                            100000).toFixed(2))}} <span class="unit">{{ $t('unit.km') }}</span></div>
                    </div>
                </div>
                <div class="cal-box">
                    <div class="cal-total value-font">{{format(parseInt(item.calorie / 1000))}}
                        <span class="unit">{{ $t('unit.kcal') }}</span>
                    </div>
                    <img v-if="item.calorieVariation == 0" class="cal-icon-flat" src="@/assets/report/weekly/flat.png">
                    <img v-if="item.calorieVariation > 0" class="cal-icon" src="@/assets/report/month/up.png">
                    <img v-if="item.calorieVariation < 0" class="cal-icon" src="@/assets/report/weekly/down.png">
                    <div class="cal-variation value-font">{{format(Math.abs(parseInt(item.calorieVariation / 1000)))}} <span
                            class="unit">{{ $t('unit.kcal') }}</span></div>
                    <div class="cal-chart" id="cal"></div>
                    <canvas id="myCanvas"></canvas>
                    <div class="canvas-text value-font">
                        <div class="canvas-value">{{item.calorieDayCompliance}}</div>
                    </div>
                    <div class="cal-ratio-box">
                        <div v-if="lineWidth5" class="line-1 line" :style="{'width': lineWidth5 + 'px'}"></div>
                        <div v-if="lineWidth6" class="line-2 line" :style="{'width': lineWidth6 + 'px'}"></div>
                        <div v-if="lineWidth7" class="line-3 line" :style="{'width': lineWidth7 + 'px'}"></div>
                        <div v-if="lineWidth8" class="line-4 line" :style="{'width': lineWidth8 + 'px'}"></div>
                    </div>
                    <div>
                        <div class="bar bar5"></div>
                        <div class="text text5">{{getLangSportType(item.monthCalories[0].type)}}</div>
                        <div class="value-font-mini bar-value5">{{(item.monthCalories[0].value * 100).toFixed(1)}}%</div>
                    </div>
                    <div>
                        <div class="bar bar6"></div>
                        <div class="text text6">{{getLangSportType(item.monthCalories[1].type)}}</div>
                        <div class="value-font-mini bar-value6">{{(item.monthCalories[1].value * 100).toFixed(1)}}%</div>
                    </div>
                    <div>
                        <div class="bar bar7"></div>
                        <div class="text text7">{{getLangSportType(item.monthCalories[2].type)}}</div>
                        <div class="value-font-mini bar-value7">{{(item.monthCalories[2].value * 100).toFixed(1)}}%</div>
                    </div>
                    <div>
                        <div class="bar bar8"></div>
                        <div class="text text8">{{getLangSportType(item.monthCalories[3].type)}}</div>
                        <div class="value-font-mini bar-value8">{{(item.monthCalories[3].value * 100).toFixed(1)}}%</div>
                    </div>
                </div>
                <div class="medal-box">
                    <div class="no-medal" v-if="item.medal == 0">{{ $t('newMonth.noMedal') }}<img class="refule" src="@/assets/report/month/refuel.png"></div>
                    <div v-if="item.medal > 0">
                        <div class="have-medal-left">{{ $t('newMonth.add0') }}<span class="medal-num">{{item.medal}}</span>{{ $t('newMonth.add1') }}</div>
                        <div class="have-medal-right">{{ $t('newMonth.more0') }}<span
                                class="medal-num light">{{parseInt(item.medalRatio*100)}}%</span>{{ $t('newMonth.more1') }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="no-content" v-if="!item">
            <img class="no-icon" src="@/assets/theme/light/report/03month/05no.png">
            <div class="no-time-range">
                <div>{{month ? month : ''}}</div>
                <div>暂无月报</div>
            </div>
        </div>
    </div>

</template>

<script>
    import {format} from '@/utils/math'
    import {getMonthDays, changeDate} from '@/utils/dateUtils'
    import {getQueryVariable, getSkin} from '@/utils/comment'
    import {WebJSBridge} from "../../utils/JSBridge1";

    export default {
        name: 'month',
        data() {
            return {
                theme: 'light',
                defaultImg: require('@/assets/share/home/noImg.png'),
                item: {},
                lineWidth1: 124 * 0.4,
                lineWidth2: 124 * 0.3,
                lineWidth3: 124 * 0.2,
                lineWidth4: 124 * 0.1,
                lineWidth5: 307 * 0.4,
                lineWidth6: 307 * 0.3,
                lineWidth7: 307 * 0.2,
                lineWidth8: 307 * 0.1,
                month: getQueryVariable('month'),
            }
        },
        mounted() {
            this.theme = this.$route.query.theme ? this.$route.query.theme : 'light';
            if (this.$route.query.token) {
                localStorage.setItem("token", this.$route.query.token);
            }
            this.getSportMonthDes();
        },
        methods: {
            back() {
                if (window.history.length == 1) {
                    this.$router.push({
                        name: 'list',
                        query: {
                            lang: this.$i18n.locale,
                            theme: this.theme
                        }
                    })
                } else {
                    this.$router.back();
                }

            },
            share() {
                WebJSBridge.call("shareReport", null, function (res) {
                    console.log("recieve callback")
                    console.log(res)
                });
            },
            toHistory() {
                this.$router.push({
                    name: 'newMonthHistory',
                    query: {
                        lang: this.$i18n.locale,
                        theme: this.theme
                    }
                })
            },
            getSportMonthDes() {
                this.$api.report.getSportMonthDes({
                    startDate: this.month ? this.month + '-01' : ''
                }).then(res => {
                    this.item = res.info;
                    if (this.item) {
                        let days = getMonthDays(this.item.monthBegin);
                        this.item.stepDayComplianceRatio = this.item.stepDayCompliance / days * 100;
                        this.dealWeeklyDuration();
                        this.$nextTick(function () {
                            this.drawChart('step', JSON.parse(this.item.daySteps), getSkin('--chart-color-1'));
                            this.drawCalChart('cal', JSON.parse(this.item.weekCalorie), getSkin('--chart-color-3'));
                            let clientWidth = document.documentElement.clientWidth;
                            let ratio = clientWidth / 375;
                            this.drawRing(this.item.calorieDayCompliance / days * 100, ratio);
                        })
                    }
                })
            },
            dealWeeklyDuration() {
                let duration = [];
                let od = JSON.parse(this.item.weekDuration);
                let max = Math.max.apply(Math, od.map(function (o) {
                    return o.value
                }));
                for (let i = 0; i < od.length; i++) {
                    let key;
                    if (od[i].startDate == od[i].endDate) {
                        key = changeDate(od[i].startDate);
                    } else {
                        key = changeDate(od[i].startDate) + '-' + changeDate(od[i].endDate)
                    }
                    duration.push({
                        key: key,
                        value: (od[i].value / 3600).toFixed(2),
                        isMax: max == od[i].value
                    })
                }
                this.item.weekDurationDeal = duration;
                this.item.monthDuration = JSON.parse(this.item.monthDuration);
                this.lineWidth1 = 124 * this.item.monthDuration[0].value;
                this.lineWidth2 = 124 * this.item.monthDuration[1].value;
                this.lineWidth3 = 124 * this.item.monthDuration[2].value;
                this.lineWidth4 = 124 * this.item.monthDuration[3].value;
                this.item.monthCalories = JSON.parse(this.item.monthCalories);
                this.lineWidth5 = 307 * this.item.monthCalories[0].value;
                this.lineWidth6 = 307 * this.item.monthCalories[1].value;
                this.lineWidth7 = 307 * this.item.monthCalories[2].value;
                this.lineWidth8 = 307 * this.item.monthCalories[3].value;
            },
            format(n) {
                return format(n)
            },
            drawChart(id, odata, color) {
                let d = [];
                let data = [];
                for (let i = 0; i < odata.length; i++) {
                    d.push(changeDate(odata[i].date));
                    data.push(odata[i].value)
                }
                let myChart = this.$echarts.init(document.getElementById(id), null, { renderer: 'svg'});
                myChart.setOption({
                    grid: {
                        top: 15,
                        bottom: 20,
                        left: 15,
                        right: 50
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            show: false,
                        },
                        axisLabel: {
                            fontSize: 12,
                            textStyle: {
                                color: '#000000'
                            }
                        },
                        axisTick: {
                            show: false
                        },
                        splitLine: {
                            show: false
                        },
                        data: d
                    },
                    yAxis: {
                        type: 'value',
                        position: 'right',
                        axisLabel: {
                            show: false
                        },
                        splitLine: {
                            show: false
                        }
                    },
                    series: [
                        {
                            data: data,
                            type: 'bar',
                            lineStyle: {
                                width: 3
                            },
                            barWidth: 5,
                            itemStyle: {
                                // 柱形图圆角，鼠标移上去效果，如果只是一个数字则说明四个参数全部设置为那么多
                                normal: {
                                    // 柱形图圆角，初始化效果
                                    barBorderRadius: [15, 15, 0, 0],
                                    //color配置字体的颜色
                                    color: function (params) {
                                        var index_color = params.value;
                                        if (index_color === Math.max.apply(null, data)) {//Math.max.apply获取数据源中的的最大值
                                            return color;//Echarts的渐变色设置
                                        } else {
                                            return getSkin('--chart-color-23')
                                        }

                                    },
                                }
                            },
                            markPoint: {
                                symbolSize: [0, 8], // 容器大小
                                symbolOffset: [0, -5], //位置偏移
                                data: [
                                    {type: 'max', name: '最大值'},
                                ],
                                label: {
                                    offset: [0, 0],
                                    textStyle: {
                                        color: color,
                                    },
                                    formatter: function (e) {
                                        return format(parseInt(e.value));
                                    }
                                },
                            },
                            markLine: {
                                symbol: "none",
                                data: [
                                    {
                                        type: "average",
                                        name: "平均值",
                                        symbol: "none",
                                        silent: false,
                                        lineStyle: { // 警戒线样式
                                            color: '#000000'
                                        },
                                        label: {
                                            color: '#000000',
                                            formatter: function (e) {
                                                return format(parseInt(e.value));
                                            }
                                        },
                                    }
                                ]
                            }
                        }
                    ]
                }, true);
            },
            drawCalChart(id, odata, color) {
                let d = [];
                let data = [];
                for (let i = 0; i < odata.length; i++) {
                    let k = i + 1;
                    if (this.$i18n.locale != 'en') {
                        k = k + '周'
                    } else {
                        k = 'W' + k
                    }
                    d.push(k);
                    data.push(parseInt(odata[i].value / 1000))
                }
                let myChart = this.$echarts.init(document.getElementById(id), null, { renderer: 'svg'});
                myChart.setOption({
                    grid: {
                        top: 15,
                        bottom: 20,
                        left: 0,
                        right: 50
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            show: false,
                        },
                        axisLabel: {
                            fontSize: 12,
                            textStyle: {
                                color: getSkin('--text-color-3')
                            }
                        },
                        axisTick: {
                            show: false
                        },
                        splitLine: {
                            show: false
                        },
                        data: d
                    },
                    yAxis: {
                        type: 'value',
                        position: 'right',
                        axisLabel: {
                            show: false
                        },
                        splitLine: {
                            show: false
                        }
                    },
                    series: [
                        {
                            data: data,
                            type: 'bar',
                            lineStyle: {
                                width: 3
                            },
                            barWidth: 8,
                            itemStyle: {
                                // 柱形图圆角，鼠标移上去效果，如果只是一个数字则说明四个参数全部设置为那么多
                                normal: {
                                    // 柱形图圆角，初始化效果
                                    barBorderRadius: [15, 15, 0, 0],
                                    //color配置字体的颜色
                                    color: function (params) {
                                        var index_color = params.value;
                                        if (index_color === Math.max.apply(null, data)) {//Math.max.apply获取数据源中的的最大值
                                            return color;//Echarts的渐变色设置
                                        } else {
                                            return 'rgba(255, 212, 194, 1)'
                                        }
                                    },
                                }
                            },
                            markPoint: {
                                symbolSize: [0, 8], // 容器大小
                                symbolOffset: [0, -5], //位置偏移
                                data: [
                                    {type: 'max', name: '最大值'},
                                ],
                                label: {
                                    offset: [0, 0],
                                    textStyle: {
                                        color: color,
                                    },
                                    formatter: function (e) {
                                        return format(parseInt(e.value));
                                    }
                                },
                            },
                            markLine: {
                                symbol: "none",
                                data: [
                                    {
                                        type: "average",
                                        name: "平均值",
                                        symbol: "none",
                                        silent: false,
                                        lineStyle: { // 警戒线样式
                                            color: '#000000'
                                        },
                                        label: {
                                            color: '#000000',
                                            formatter: function (e) {
                                                return format(parseInt(e.value));
                                            }
                                        },
                                    }
                                ]
                            }
                        }
                    ]
                }, true);
            },
            drawRing(val, ratio) {
                //先创建一个canvas画布对象，设置宽高，val%百分比
                var c = document.getElementById('myCanvas');
                var devicePixelRatio = window.devicePixelRatio || 1;
                var ctx = c.getContext('2d');
                ctx.canvas.width = ratio * 100 * devicePixelRatio;
                ctx.canvas.height = ratio * 100 * devicePixelRatio;
                ctx.scale(devicePixelRatio, devicePixelRatio);
                //圆环有两部分组成，底部灰色完整的环，根据百分比变化的环
                //先绘制底部完整的环
                //起始一条路径
                ctx.beginPath();
                //设置当前线条的宽度
                ctx.lineWidth = ratio * 10;//10px
                //设置笔触的颜色
                ctx.strokeStyle = 'rgba(255, 212, 194, 1)';
                //arc()方法创建弧/曲线（用于创建圆或部分圆）arc(圆心x,圆心y,半径,开始角度,结束角度)
                ctx.arc(ratio * 50, ratio * 50, ratio * 40, 0, 2 * Math.PI);
                //绘制已定义的路径
                ctx.stroke();

                //绘制根据百分比变动的环
                ctx.beginPath();
                ctx.lineWidth = ratio * 10;
                ctx.lineCap = 'round';
                ctx.strokeStyle = getSkin('--chart-color-3');
                ctx.shadowBlur = ratio * 5
                //设置开始处为0点钟方向（-90*Math.PI/180）
                //x为百分比值（0-100）
                ctx.arc(ratio * 50, ratio * 50, ratio * 40, -Math.PI / 2, (val * 3.6 - 90) * Math.PI / 180); //从-PI/2转到PI/10
                ctx.stroke();
                ctx.beginPath();
                ctx.fill();
                ctx.stroke();
            },
            getLangSportType(item) {
                if (item == '游泳') item = '室内游泳'
                return this.$t('sportType.' + item);
            },
        }
    }
</script>

<style scoped>
    @import "../../assets/font/font.css";

    .title-none {
        width: 375px;
        height: 88px;
        position: relative;
    }

    .title {
        background: url("~@/assets/theme/light/report/03month/01bg1.svg");
        background-size: 375px;
        width: 375px;
        height: 88px;
        position: relative;
    }

    .back {
        width: 22px;
        height: 22px;
        position: absolute;
        left: 15px;
        top: 55px;
    }

    .share-icon {
        position: absolute;
        width: 22px;
        height: 22px;
        top: 55px;
        right: 47px;
    }

    .history-icon {
        position: absolute;
        width: 22px;
        height: 22px;
        top: 55px;
        right: 15px;
    }


    .bg {
        background: url("~@/assets/theme/light/report/03month/02bg2.svg");
        background-size: 375px;
        width: 375px;
        height: 1333px;
        position: relative;
    }

    .bg-en {
        background: url("~@/assets/theme/light/report/03month/02bg2en.png");
        background-size: 375px;
        width: 375px;
        height: 1333px;
        position: relative;
    }

    .user-img {
        width: 33px;
        height: 33px;
        background: #FFFFFF;
        opacity: 1;
        border: 2px solid var(--bg-color-5);
        border-radius: 50%;
        position: absolute;
        top: 8px;
        left: 26px;
    }

    .user-name {
        font-weight: bold;
        color: #ffffff;
        font-size: 14px;
        position: absolute;
        top: 9px;
        left: 69px;
    }

    .time-range {
        color: #ffffff;
        font-size: 12px;
        position: absolute;
        left: 69px;
        top: 28px;
    }

    .run-icon {
        width: 155px;
        position: absolute;
        right: 7px;
        top: 8px;
    }

    .step-ratio-box {
        color: #000000;
        font-size: 14px;
        position: absolute;
        left: 130px;
        top: 175px;
        width: 60px;
        text-align: center;
    }

    .step-ratio {
        font-family: Bold;
        font-size: 30px;
        color: var(--chart-color-1);
    }

    .step-ratio-box-en {
        left: 105px;
    }

    .value-font {
        font-size: 30px;
        position: absolute;
        font-family: Bold;
        letter-spacing: 1px;
        color: #000000;
    }

    .step-total {
        left: 72px;
        top: 243px;
    }

    .unit {
        font-size: 12px;
        color: var(--text-color-2);
    }

    .step-variation {
        left: 231px;
        top: 243px;
    }

    .step-icon-flat {
        position: absolute;
        width: 13px;
        left: 213px;
        top: 260px;
    }

    .step-icon {
        position: absolute;
        width: 13px;
        left: 213px;
        top: 254px;
    }

    .step-chart {
        position: absolute;
        left: 41px;
        top: 283px;
        width: 300px;
        height: 100px;
    }

    .percent {
        position: absolute;
        left: 37px;
        top: 406px;
        width: 178px;
    }

    /deep/ .van-progress__pivot {
        display: none !important;
    }

    /deep/ .van-progress {
        border: 1px solid #000000;
        border-radius: 10px;
        height: 9px !important;
    }

    /deep/ .van-progress__portion {
        border-radius: 10px;
        border: 1px solid #000000;
        height: 11px;
        left: -2px;
        top: -2px;
    }

    .step-complate {
        left: 293px;
        top: 388px;
    }

    .sport-total {
        left: 44px;
        top: 502px;
    }

    .sport-icon-flat {
        position: absolute;
        width: 13px;
        left: 179px;
        top: 520px;
    }

    .sport-icon {
        position: absolute;
        width: 13px;
        left: 179px;
        top: 512px;
    }

    .sport-variation {
        left: 196px;
        top: 502px;
    }

    .value-font-mini {
        font-size: 17px;
        position: absolute;
        font-family: Bold;
        letter-spacing: 1px;
        color: #000000;
    }

    .week1 {
        left: 44px;
        top: 584px;
    }

    .value1 {
        left: 120px;
        top: 584px;
        width: 65px;
        text-align: center;
    }

    .week2 {
        left: 44px;
        top: 613px;
    }

    .value2 {
        left: 120px;
        top: 613px;
        width: 65px;
        text-align: center;
    }

    .week3 {
        left: 44px;
        top: 643px;
    }

    .value3 {
        left: 120px;
        top: 643px;
        width: 65px;
        text-align: center;
    }

    .week4 {
        left: 44px;
        top: 673px;
    }

    .value4 {
        left: 120px;
        top: 673px;
        width: 65px;
        text-align: center;
    }

    .week5 {
        left: 44px;
        top: 703px;
    }

    .value5 {
        left: 120px;
        top: 703px;
        width: 65px;
        text-align: center;
    }

    .value-max {
        color: var(--chart-color-1) !important;
    }

    .line {
        height: 9px;
        border: 1px solid #000000;
        border-radius: 5px 5px 5px 5px;
        display: inline-block;
    }

    .sport-ratio-box {
        position: absolute;
        left: 197px;
        top: 598px;
        font-size: 0;
    }

    .line-1 {
        background: linear-gradient(270deg, #ffffff 0%, var(--chart-color-1) 100%);
    }

    .line-2 {
        background: linear-gradient(270deg, #ffffff 0%, var(--chart-color-8) 100%);
    }

    .line-3 {
        background: linear-gradient(270deg, #ffffff 0%, var(--chart-color-10) 100%);
    }

    .line-4 {
        background: linear-gradient(270deg, #ffffff 0%, var(--chart-color-24) 100%);
    }

    .bar {
        width: 9px;
        height: 9px;
        border-radius: 5px 5px 5px 5px;
        opacity: 1;
        border: 1px solid #000000;
        position: absolute;
    }

    .bar1 {
        background: linear-gradient(270deg, #ffffff 0%, var(--chart-color-1) 100%);
        left: 196px;
        top: 625px;
    }

    .bar2 {
        background: linear-gradient(270deg, #ffffff 0%, var(--chart-color-8) 100%);
        left: 270px;
        top: 625px;
    }

    .bar3 {
        background: linear-gradient(270deg, #ffffff 0%, var(--chart-color-10) 100%);
        left: 196px;
        top: 675px;
    }

    .bar4 {
        background: linear-gradient(270deg, #ffffff 0%, var(--chart-color-24) 100%);
        left: 270px;
        top: 675px;
    }

    .text {
        color: #000000;
        font-size: 12px;
        position: absolute;
        width: 57px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .cal-box .text {
        width: 67px !important;
    }

    .text1 {
        left: 211px;
        top: 622px;
    }

    .text2 {
        left: 285px;
        top: 622px;
    }

    .text3 {
        left: 211px;
        top: 672px;
    }

    .text4 {
        left: 285px;
        top: 672px;
    }

    .bar-value1 {
        left: 211px;
        top: 639px;
    }

    .bar-value2 {
        left: 285px;
        top: 639px;
    }

    .bar-value3 {
        left: 211px;
        top: 690px;
    }

    .bar-value4 {
        left: 285px;
        top: 690px;
    }

    .sport-num {
        left: 41px;
        top: 763px;
    }

    .sport-num-icon-flat {
        position: absolute;
        width: 13px;
        left: 179px;
        top: 782px;
    }

    .sport-num-icon {
        position: absolute;
        width: 13px;
        left: 179px;
        top: 774px;
    }

    .sport-num-variation {
        left: 197px;
        top: 763px;
    }

    .sport-distance {
        left: 41px;
        top: 831px;
    }

    .sport-distance-icon-flat {
        position: absolute;
        width: 13px;
        left: 179px;
        top: 850px;
    }

    .sport-distance-icon {
        position: absolute;
        width: 13px;
        left: 179px;
        top: 842px;
    }

    .sport-distance-variation {
        left: 197px;
        top: 831px;
    }

    .cal-total {
        top: 945px;
        left: 110px;
    }

    .cal-icon-flat {
        position: absolute;
        width: 13px;
        left: 232px;
        top: 964px;
    }

    .cal-icon {
        position: absolute;
        width: 13px;
        left: 232px;
        top: 956px;
    }

    .cal-variation {
        left: 250px;
        top: 945px;
    }

    .cal-chart {
        position: absolute;
        left: 64px;
        top: 1001px;
        width: 190px;
        height: 90px;
    }

    #myCanvas {
        position: absolute;
        left: 255px;
        top: 1030px;
        width: 62px;
        height: 62px;
    }

    .canvas-text {
        position: absolute;
        left: 255px;
        top: 1030px;
        width: 62px;
        height: 62px;
        text-align: center;
    }

    .canvas-value {
        margin-top: 11px;
    }

    .cal-ratio-box {
        position: absolute;
        left: 30px;
        top: 1120px;
        font-size: 0;
    }

    .bar5 {
        background: linear-gradient(270deg, #ffffff 0%, var(--chart-color-1) 100%);
        left: 30px;
        top: 1146px;
    }

    .bar6 {
        background: linear-gradient(270deg, #ffffff 0%, var(--chart-color-8) 100%);
        left: 118px;
        top: 1146px;
    }

    .bar7 {
        background: linear-gradient(270deg, #ffffff 0%, var(--chart-color-10) 100%);
        left: 206px;
        top: 1146px;
    }

    .bar8 {
        background: linear-gradient(270deg, #ffffff 0%, var(--chart-color-24) 100%);
        left: 290px;
        top: 1146px;
    }

    .text5 {
        left: 45px;
        top: 1144px;
    }

    .text6 {
        left: 133px;
        top: 1144px;
    }

    .text7 {
        left: 221px;
        top: 1144px;
    }

    .text8 {
        left: 305px;
        top: 1144px;
    }

    .bar-value5 {
        left: 45px;
        top: 1160px;
    }

    .bar-value6 {
        left: 133px;
        top: 1160px;
    }

    .bar-value7 {
        left: 221px;
        top: 1160px;
    }

    .bar-value8 {
        left: 305px;
        top: 1160px;
    }

    .no-medal {
        font-size: 14px;
        color: #000000;
        position: absolute;
        left: 40px;
        bottom: 52px;
    }

    .refule {
        width: 18px;
        margin-left: 5px;
    }

    .have-medal-left {
        color: #000000;
        font-size: 12px;
        position: absolute;
        left: 49px;
        bottom: 44px;
    }

    .medal-num {
        font-size: 30px;
        font-family: Bold;
        letter-spacing: 1px;
        color: #000000;
        margin: 0 6px;
    }

    .have-medal-right {
        color: #000000;
        font-size: 12px;
        position: absolute;
        left: 150px;
        bottom: 44px;
    }

    .light {
        color: var(--chart-color-1);
    }

    .week {
        position: absolute;
        width: 140px;
        height: auto;
        left: 44px;
        top: 580px;
        font-size: 17px;
        font-family: Bold;
        letter-spacing: 1px;
        color: #000000;
        line-height: 27px;
    }

    .week-item {
        display: inline-block;
    }

    .week-item-right {
        width: 55px;
        display: inline-block;
        text-align: center;
        float: right;
    }

    .no-content {
        width: 100%;
        height: 100%;
        position: relative;
    }

    .no-icon {
        width: 183px;
        position: absolute;
        top: 55px;
        left: 94px;
    }

    .no-time-range {
        padding-top: 200px;
        text-align: center;
        color: #999999;
        font-size: 15px;
    }

    .no-time-range div {
        margin-bottom: 9px;
    }
</style>



// WEBPACK FOOTER //
// src/views/report/03month.vue